import React from 'react'
import Text from '../../components/text/Text'
import posnetCheck from '../../assets/icons/posnet-check.png'
import './posPayment.css'
import { useLocation, useNavigate } from 'react-router-dom'
import routes from '../../router/routes'
import SvgIcon from '../../components/svgIcon/SvgIcon'

const PosPayment = () => {
    const navigation = useNavigate()
    const location = useLocation()

    const total = location.state?.total
    const file = location.state?.fileInvoice

    const openPdf = () => {
        const byteCharacters = atob(file)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        window.open(url)
    }

    return (
        <div className="posPayment-main">
            <div>
                <img
                    src={posnetCheck}
                    height={88}
                    width={88}
                    style={{
                        alignSelf: 'center',
                        marginBottom: 26,
                    }}
                />
                <Text
                    label={`Se registró una venta con un dispositivo POS por\nun monto de: ${total}`}
                    fontFamily={'Poppins'}
                    textAlign={'center'}
                    fontSize={20}
                    fontWeight={700}
                    color={'#676767'}
                />
                <Text
                    label={`Recuerda que los registros de ventas con\ndispositivos POS`}
                    fontFamily={'Poppins'}
                    textAlign={'center'}
                    fontSize={20}
                    fontWeight={400}
                    color={'#676767'}
                />
                <Text
                    label={`no será registrado en la proforma\namiPASS.`}
                    fontFamily={'Poppins'}
                    textAlign={'center'}
                    fontSize={20}
                    fontWeight={700}
                    color={'#676767'}
                />
                <div
                    style={{
                        marginTop: 15,
                        marginBottom: 5,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {file ? (
                        <button
                            onClick={openPdf}
                            style={{
                                gap: 7,
                                display: 'flex',
                                cursor: 'pointer',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            }}
                        >
                            <Text
                                label="Descargar la boleta en PDF"
                                variant="bold"
                            />
                            <SvgIcon iconName="PdfIcon" />
                        </button>
                    ) : (
                        <div
                            style={{
                                gap: 7,
                                maxWidth: 350,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <div style={{ width: 30 }}>
                                <SvgIcon iconName="warning" />
                            </div>
                            <Text
                                variant="Caption3-13"
                                label="Se presentó un problema para generar la boleta electrónica. Por favor contacta a nuestro equipo de soporte."
                            />
                        </div>
                    )}
                </div>
            </div>
            <div
                onClick={() => navigation(`/${routes.payment}`)}
                style={{
                    height: 72,
                    width: 249,
                    backgroundColor: '#00BB2D',
                    borderRadius: 14,
                    alignContent: 'center',
                    cursor: 'pointer',
                    marginTop: 17,
                }}
            >
                <Text
                    label={`Realizar otra venta`}
                    fontFamily={'Montserrat'}
                    textAlign={'center'}
                    fontSize={16}
                    fontWeight={600}
                    color={'white'}
                />
            </div>
        </div>
    )
}

export default PosPayment
